<template>
  <div class="property-config">
    <!-- 触发按钮 -->
    <el-button 
      type="primary" 
      size="small" 
      @click="dialogVisible = true"
      icon="el-icon-setting"
    >
      属性配置
    </el-button>
    
    <!-- 自定义弹窗 -->
    <div v-if="dialogVisible" class="my-dialog-mask" @click.self="closeDialog">
      <div class="my-dialog-box" tabindex="0" @keydown.esc="closeDialog">
        <div class="my-dialog-header">
          <span class="my-dialog-title">属性配置</span>
          <i class="el-icon-close my-dialog-close" @click="closeDialog"></i>
        </div>
        <div class="my-dialog-body">
          <div class="config-content">
            <!-- 配置类型选择 -->
            <div class="config-tabs">
              <el-tabs v-model="activeTab" type="card">
                <el-tab-pane label="排序配置" name="sort">
                  <div class="tab-content">
                    <!-- 排序配置内容 -->
                    <div class="config-section">
                      <div class="section-header">
                        <h4 class="section-title">
                          <i class="el-icon-sort"></i>
                          排序功能配置
                        </h4>
                        <el-switch
                          v-model="sortConfig.enableSort"
                          active-text="启用"
                          inactive-text="禁用"
                        />
                      </div>
                      
                      <div v-if="sortConfig.enableSort" class="section-content">
                        <!-- 基础配置 -->
                        <el-form :model="sortConfig" label-width="120px" class="config-form">
                          <el-form-item label="最大排序数量">
                            <el-input-number
                              v-model="sortConfig.maxSortCount"
                              :min="1000"
                              :max="50000"
                              :step="1000"
                              style="width: 200px"
                            />
                            <span class="form-tip">建议范围：5000-20000</span>
                          </el-form-item>
                          
                          <!-- 在线状态优先级说明 -->
                          <div class="priority-explanation">
                            <h5 class="explanation-title">
                              <i class="el-icon-info"></i>
                              在线状态优先级说明: 
                            </h5>
                            <div class="priority-list">
                              <div class="priority-item">
                                <div class="priority-line">优先级:</div>
                                <div class="priority-line">1.在线-空闲-工作状态 > 2.在线-空闲-非工作状态 > 3.在线-Live</div>
                                <div class="priority-line">4.在线-机器人匹配(&lt;20 秒) > 5.在线-机器人匹配(&gt;20 秒) > 6.在线-匹配通话中</div>
                                <div class="priority-line"> 7.在线-私ca11中 > 离线状态</div>
                              </div>
                            </div>
                          </div>
                        </el-form>
                        
                        <!-- 一级排序配置 -->
                        <div class="sort-section">
                          <h5 class="subsection-title">
                            <i class="el-icon-sort-up"></i>
                            一级排序（分组排序）
                          </h5>
                          <el-form :model="sortConfig.primarySort" label-width="120px" class="config-form">
                            <el-form-item label="排序类型">
                              <el-radio-group v-model="sortConfig.primarySort.type">
                                <el-radio label="country">国家优先</el-radio>
                                <el-radio label="language">语言优先</el-radio>
                                <el-radio label="null">空</el-radio>
                              </el-radio-group>
                            </el-form-item>
                            
                            <el-form-item label="优先级列表">
                              <el-select
                                v-model="sortConfig.primarySort.priorities"
                                multiple
                                filterable
                                collapse-tags
                                placeholder="请选择优先级"
                                style="width: 100%"
                              >
                                <el-option
                                  v-for="item in availableOptions"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                              <div class="form-tip">
                                {{ sortConfig.primarySort.type === 'country' ? '选择国家优先级' : '选择语言优先级' }}
                              </div>
                            </el-form-item>
                          </el-form>
                        </div>
                        
                        <!-- 二级排序配置 -->
                        <div class="sort-section">
                          <h5 class="subsection-title">
                            <i class="el-icon-sort-down"></i>
                            二级排序（组内排序）
                          </h5>
                          <el-form :model="sortConfig.secondarySort" label-width="120px" class="config-form">
                            <el-form-item label="排序字段">
                              <el-radio-group v-model="sortConfig.secondarySort.field">
                                <el-radio label="duration">通话时长</el-radio>
                                <el-radio label="income">总收入</el-radio>
                                <el-radio label="matchScore">匹配分</el-radio>
                                <el-radio label="null">空</el-radio>
                              </el-radio-group>
                            </el-form-item>
                            
                            <el-form-item label="排序方向">
                              <el-radio-group v-model="sortConfig.secondarySort.direction">
                                <el-radio label="desc">降序（从高到低）</el-radio>
                                <el-radio label="asc">升序（从低到高）</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </el-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                
                <!-- 认证配置标签页 -->
                <el-tab-pane label="认证配置" name="certificate">
                  <div class="tab-content">
                    <div class="config-section">
                      <div class="section-header">
                        <h4 class="section-title">
                          <i class="el-icon-success"></i>
                          认证功能配置
                        </h4>
                        <el-switch
                          v-model="certificateConfig.enableCertificate"
                          active-text="启用"
                          inactive-text="禁用"
                          @change="handleCertificateEnableChange"
                        />
                      </div>
                      
                      <div v-if="certificateConfig.enableCertificate" class="section-content">
                        <el-form :model="certificateConfig" label-width="120px" class="config-form">
                          <el-form-item label="认证类型">
                            <el-checkbox-group v-model="certificateConfig.certificateType">
                              <el-checkbox :label="1">性别认证(1)</el-checkbox>
                              <el-checkbox :label="2">真人认证(2)</el-checkbox>
                              <el-checkbox :label="3">头像认证(3)</el-checkbox>
                            </el-checkbox-group>
                            <div class="form-tip">选择需要的认证类型</div>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                
                <!-- 行为配置标签页 -->
                <el-tab-pane label="行为配置" name="behavior">
                  <div class="tab-content">
                    <div class="config-section">
                      <div class="section-header">
                        <h4 class="section-title">
                          <i class="el-icon-user"></i>
                          行为功能配置
                        </h4>
                        <el-switch
                          v-model="behaviorConfig.enableBehavior"
                          active-text="启用"
                          inactive-text="禁用"
                        />
                      </div>
                      
                      <div v-if="behaviorConfig.enableBehavior" class="section-content">
                        <el-form :model="behaviorConfig" label-width="120px" class="config-form">
                          <el-form-item label="行为类型">
                            <el-select
                              v-model="behaviorConfig.behaviorType"
                              placeholder="请选择行为类型"
                              style="width: 200px"
                            >
                              <el-option
                                label="通话"
                                value="chat"
                              />
                              <el-option
                                label="收礼"
                                value="gift"
                              />
                              <el-option
                                label="关注"
                                value="follow"
                              />
                            </el-select>
                            <div class="form-tip">选择要统计的行为类型</div>
                          </el-form-item>
                          
                          <el-form-item label="统计天数">
                            <el-input-number
                              v-model="behaviorConfig.day"
                              :min="1"
                              :max="365"
                              :step="1"
                              style="width: 200px"
                            />
                            <span class="form-tip">统计最近N天的行为数据</span>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                
                <!-- AI电话配置标签页 -->
                <el-tab-pane label="AI电话配置" name="aiChat">
                  <div class="tab-content">
                    <div class="config-section">
                      <div class="section-header">
                        <h4 class="section-title">
                          <i class="el-icon-phone"></i>
                          AI电话功能配置
                        </h4>
                        <el-switch
                          v-model="aiChatConfigBO.enableAiChat"
                          active-text="启用"
                          inactive-text="禁用"
                        />
                      </div>
                      
                      <div v-if="aiChatConfigBO.enableAiChat" class="section-content">
                        <el-form :model="aiChatConfigBO" label-width="180px" class="config-form">
                          <el-form-item label="每日补贴收入上限">
                            <el-input-number
                              v-model="aiChatConfigBO.dailyRevenueUpperLimit"
                              :min="0"
                              :step="1"
                              style="width: 200px"
                            />
                            <span class="form-tip">设置每日补贴收入上限</span>
                          </el-form-item>
                          
                          <el-form-item label="每周补贴收入上限">
                            <el-input-number
                              v-model="aiChatConfigBO.weeklyRevenueUpperLimit"
                              :min="0"
                              :step="1"
                              style="width: 200px"
                            />
                            <span class="form-tip">设置每周补贴收入上限</span>
                          </el-form-item>
                          
                          <el-form-item label="时间范围内补贴收入上限">
                            <el-input-number
                              v-model="aiChatConfigBO.timeRangeRevenueUpperLimit"
                              :min="0"
                              :step="1"
                              style="width: 200px"
                            />
                            <span class="form-tip">设置时间范围内补贴收入上限</span>
                          </el-form-item>
                          
                          <el-form-item label="时间范围内补贴收入下限">
                            <el-input-number
                              v-model="aiChatConfigBO.timeRangeRevenueLowerLimit"
                              :min="0"
                              :step="1"
                              style="width: 200px"
                            />
                            <span class="form-tip">设置时间范围内补贴收入下限</span>
                          </el-form-item>
                          
                          <el-form-item label="每通电话补贴上限">
                            <el-input-number
                              v-model="aiChatConfigBO.chatRevenueUpperLimit"
                              :min="0"
                              :step="1"
                              style="width: 200px"
                            />
                            <span class="form-tip">设置每通电话补贴上限</span>
                          </el-form-item>
                          
                          <el-form-item label="每通电话补贴下限">
                            <el-input-number
                              v-model="aiChatConfigBO.chatRevenueLowerLimit"
                              :min="0"
                              :step="1"
                              style="width: 200px"
                            />
                            <span class="form-tip">设置每通电话补贴下限</span>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                
                <!-- 预留其他配置标签页 -->
                <!-- <el-tab-pane label="其他配置" name="other">
                  <div class="tab-content">
                    <div class="config-section">
                      <div class="section-header">
                        <h4 class="section-title">
                          <i class="el-icon-setting"></i>
                          其他功能配置
                        </h4>
                      </div>
                      <div class="section-content">
                        <p class="placeholder-text">其他配置功能开发中...</p>
                      </div>
                    </div>
                  </div>
                </el-tab-pane> -->
              </el-tabs>
            </div>
            
            <!-- 配置预览 -->
            <div class="config-preview">
              <h4 class="preview-title">
                <i class="el-icon-view"></i>
                配置预览
              </h4>
              <div class="preview-content">
                <pre>{{ JSON.stringify(finalConfig, null, 2) }}</pre>
              </div>
            </div>
          </div>
        </div>
        <div class="my-dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="confirmConfig">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertyConfig',
  props: {
    value: {
      type: String,
      default: ''
    },
    countryList: {
      type: Array,
      default: () => []
    },
    langList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      activeTab: 'sort',
      sortConfig: {
        enableSort: false,
        maxSortCount: 10000,
        primarySort: {
          type: 'null',
          priorities: []
        },
        secondarySort: {
          field: 'null',
          direction: 'desc'
        }
      },
      tempConfig: null,
      behaviorConfig: {
        enableBehavior: false,
        behaviorType: 'chat',
        day: 7
      },
      certificateConfig: {
        enableCertificate: false,
        certificateType: []
      },
      aiChatConfigBO: {
        enableAiChat: false,
        dailyRevenueUpperLimit: 0,
        weeklyRevenueUpperLimit: 0,
        timeRangeRevenueUpperLimit: 0,
        timeRangeRevenueLowerLimit: 0,
        chatRevenueUpperLimit: 0,
        chatRevenueLowerLimit: 0
      },
      // 通用配置定义 - 用于动态生成UI
      configDefinitions: [
        {
          id: 'sort',
          name: '排序配置',
          icon: 'el-icon-sort',
          enabledKey: 'enableSort',
          configKey: 'sortConfig',
          fields: [
            {
              key: 'maxSortCount',
              label: '最大排序数量',
              type: 'number',
              min: 1000,
              max: 50000,
              step: 1000,
              tip: '建议范围：5000-20000'
            },
            {
              key: 'primarySort',
              label: '一级排序',
              type: 'object',
              fields: [
                {
                  key: 'type',
                  label: '排序类型',
                  type: 'radio',
                  options: [
                    { label: '国家优先', value: 'country' },
                    { label: '语言优先', value: 'language' },
                    { label: '空', value: 'null' }
                  ]
                },
                {
                  key: 'priorities',
                  label: '优先级列表',
                  type: 'multiSelect',
                  options: 'dynamic'
                }
              ]
            },
            {
              key: 'secondarySort',
              label: '二级排序',
              type: 'object',
              fields: [
                {
                  key: 'field',
                  label: '排序字段',
                  type: 'radio',
                  options: [
                    { label: '通话时长', value: 'duration' },
                    { label: '总收入', value: 'income' },
                    { label: '匹配分', value: 'matchScore' },
                    { label: '空', value: 'null' }
                  ]
                },
                {
                  key: 'direction',
                  label: '排序方向',
                  type: 'radio',
                  options: [
                    { label: '降序（从高到低）', value: 'desc' },
                    { label: '升序（从低到高）', value: 'asc' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 'certificate',
          name: '认证配置',
          icon: 'el-icon-success',
          enabledKey: 'enableCertificate',
          configKey: 'certificateConfig',
          fields: [
            {
              key: 'certificateType',
              label: '认证类型',
              type: 'checkbox',
              options: [
                { label: '性别认证(1)', value: 1 },
                { label: '真人认证(2)', value: 2 },
                { label: '头像认证(3)', value: 3 }
              ],
              tip: '选择需要的认证类型'
            }
          ]
        },
        {
          id: 'behavior',
          name: '行为配置',
          icon: 'el-icon-user',
          enabledKey: 'enableBehavior',
          configKey: 'behaviorConfig',
          fields: [
            {
              key: 'behaviorType',
              label: '行为类型',
              type: 'select',
              options: [
                { label: '通话', value: 'chat' },
                { label: '收礼', value: 'gift' },
                { label: '关注', value: 'follow' }
              ],
              tip: '选择要统计的行为类型'
            },
            {
              key: 'day',
              label: '统计天数',
              type: 'number',
              min: 1,
              max: 365,
              step: 1,
              tip: '统计最近N天的行为数据'
            }
          ]
        },
        {
          id: 'aiChat',
          name: 'AI电话配置',
          icon: 'el-icon-phone',
          enabledKey: 'enableAiChat',
          configKey: 'aiChatConfigBO',
          fields: [
            {
              key: 'dailyRevenueUpperLimit',
              label: '每日补贴收入上限',
              type: 'number',
              min: 0,
              step: 1,
              tip: '设置每日补贴收入上限'
            },
            {
              key: 'weeklyRevenueUpperLimit',
              label: '每周补贴收入上限',
              type: 'number',
              min: 0,
              step: 1,
              tip: '设置每周补贴收入上限'
            },
            {
              key: 'timeRangeRevenueUpperLimit',
              label: '时间范围内补贴收入上限',
              type: 'number',
              min: 0,
              step: 1,
              tip: '设置时间范围内补贴收入上限'
            },
            {
              key: 'timeRangeRevenueLowerLimit',
              label: '时间范围内补贴收入下限',
              type: 'number',
              min: 0,
              step: 1,
              tip: '设置时间范围内补贴收入下限'
            },
            {
              key: 'chatRevenueUpperLimit',
              label: '每通电话补贴上限',
              type: 'number',
              min: 0,
              step: 1,
              tip: '设置每通电话补贴上限'
            },
            {
              key: 'chatRevenueLowerLimit',
              label: '每通电话补贴下限',
              type: 'number',
              min: 0,
              step: 1,
              tip: '设置每通电话补贴下限'
            }
          ]
        }
      ]
    }
  },
  computed: {
    availableOptions() {
      if (this.sortConfig.primarySort.type === 'country') {
        return this.countryList.map(item => ({
          label: item.country,
          value: item.countryCode
        }))
      } else {
        return this.langList.map(item => ({
          label: item.language,
          value: item.langCode
        }))
      }
    },
    
    finalConfig() {
      const config = {}
      
      // 添加排序配置
      if (this.sortConfig.enableSort) {
        config.sortConfig = this.sortConfig
      }
      
      // 添加行为配置
      if (this.behaviorConfig.enableBehavior) {
        config.behaviorConfig = {
          behaviorType: this.behaviorConfig.behaviorType,
          day: this.behaviorConfig.day
        }
      }

      // 添加认证配置
      if (this.certificateConfig.enableCertificate && this.certificateConfig.certificateType.length > 0) {
        config.certificateType = this.certificateConfig.certificateType
      }

      // 添加AI电话配置
      if (this.aiChatConfigBO.enableAiChat) {
        config.aiChatConfigBO = {
          dailyRevenueUpperLimit: this.aiChatConfigBO.dailyRevenueUpperLimit,
          weeklyRevenueUpperLimit: this.aiChatConfigBO.weeklyRevenueUpperLimit,
          timeRangeRevenueUpperLimit: this.aiChatConfigBO.timeRangeRevenueUpperLimit,
          timeRangeRevenueLowerLimit: this.aiChatConfigBO.timeRangeRevenueLowerLimit,
          chatRevenueUpperLimit: this.aiChatConfigBO.chatRevenueUpperLimit,
          chatRevenueLowerLimit: this.aiChatConfigBO.chatRevenueLowerLimit
        }
      }
      
      return config
    }
  },
  watch: {
    value: {
      handler(newVal) {
        try {
          this.parseConfig(newVal)
        } catch (error) {
          console.error('配置解析失败:', error, '输入值:', newVal)
          this.$message.error('配置解析失败，已重置为默认配置')
          this.resetConfig()
        }
      },
      immediate: true
    },
    // 监听认证配置变化，自动更新开关状态
    'certificateConfig.certificateType': {
      handler(newVal) {
        this.certificateConfig.enableCertificate = newVal && newVal.length > 0
      },
      deep: true
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false;
      this.cancelConfig && this.cancelConfig();
    },
    confirmConfig() {
      this.emitChange();
      this.dialogVisible = false;
    },
    parseConfig(jsonStr) {
      if (!jsonStr) {
        this.resetConfig()
        return
      }
      
      try {
        // 如果传入的已经是对象，直接使用；否则解析JSON字符串
        let parsed
        if (typeof jsonStr === 'string') {
          parsed = JSON.parse(jsonStr)
        } else if (typeof jsonStr === 'object') {
          parsed = jsonStr
        } else {
          console.warn('parseConfig: 无效的配置数据:', jsonStr)
          this.resetConfig()
          return
        }
        
        // 解析排序配置
        if (parsed.sortConfig) {
          this.sortConfig = {
            enableSort: parsed.sortConfig.enableSort || false,
            maxSortCount: parsed.sortConfig.maxSortCount || 10000,
            primarySort: {
              type: parsed.sortConfig.primarySort?.type || 'null',
              priorities: parsed.sortConfig.primarySort?.priorities || []
            },
            secondarySort: {
              field: parsed.sortConfig.secondarySort?.field || 'null',
              direction: parsed.sortConfig.secondarySort?.direction || 'desc'
            }
          }
        } else {
          this.sortConfig = this.getDefaultSortConfig()
        }
        
        // 解析行为配置
        if (parsed.behaviorConfig) {
          this.behaviorConfig = {
            enableBehavior: parsed.behaviorConfig?.behaviorType ? true : false,
            behaviorType: parsed.behaviorConfig.behaviorType || 'chat',
            day: parsed.behaviorConfig.day || 7
          }
        } else {
          this.behaviorConfig = this.getDefaultBehaviorConfig()
        }

        // 解析认证配置
        if (parsed.certificateType) {
          this.certificateConfig = {
            enableCertificate: parsed.certificateType && parsed.certificateType.length > 0,
            certificateType: parsed.certificateType || []
          }
        } else {
          this.certificateConfig = this.getDefaultCertificateConfig()
        }

        // 解析AI电话配置
        if (parsed.aiChatConfigBO) {
          this.aiChatConfigBO = {
            enableAiChat: parsed.aiChatConfigBO ? true : false,
            dailyRevenueUpperLimit: parsed.aiChatConfigBO.dailyRevenueUpperLimit || 0,
            weeklyRevenueUpperLimit: parsed.aiChatConfigBO.weeklyRevenueUpperLimit || 0,
            timeRangeRevenueUpperLimit: parsed.aiChatConfigBO.timeRangeRevenueUpperLimit || 0,
            timeRangeRevenueLowerLimit: parsed.aiChatConfigBO.timeRangeRevenueLowerLimit || 0,
            chatRevenueUpperLimit: parsed.aiChatConfigBO.chatRevenueUpperLimit || 0,
            chatRevenueLowerLimit: parsed.aiChatConfigBO.chatRevenueLowerLimit || 0
          }
        } else {
          this.aiChatConfigBO = this.getDefaultAiChatConfig()
        }
        
      } catch (error) {
        console.error('解析配置失败:', error)
        this.resetConfig()
      }
    },
    
    resetConfig() {
      this.sortConfig = this.getDefaultSortConfig()
      this.behaviorConfig = this.getDefaultBehaviorConfig()
      this.certificateConfig = this.getDefaultCertificateConfig()
      this.aiChatConfigBO = this.getDefaultAiChatConfig()
    },
    
    getDefaultSortConfig() {
      return {
        enableSort: false,
        maxSortCount: 10000,
        primarySort: {
          type: 'null',
          priorities: []
        },
        secondarySort: {
          field: 'null',
          direction: 'desc'
        }
      }
    },
    
    getDefaultBehaviorConfig() {
      return {
        enableBehavior: false,
        behaviorType: 'chat',
        day: 7
      }
    },

    getDefaultCertificateConfig() {
      return {
        enableCertificate: false,
        certificateType: []
      }
    },

    getDefaultAiChatConfig() {
      return {
        enableAiChat: false,
        dailyRevenueUpperLimit: 0,
        weeklyRevenueUpperLimit: 0,
        timeRangeRevenueUpperLimit: 0,
        timeRangeRevenueLowerLimit: 0,
        chatRevenueUpperLimit: 0,
        chatRevenueLowerLimit: 0
      }
    },
    
    emitChange() {
      try {
        const jsonStr = JSON.stringify(this.finalConfig)
        console.log('属性配置已更新:', jsonStr)
        this.$emit('input', jsonStr)
      } catch (error) {
        console.error('配置序列化失败:', error, this.finalConfig)
        this.$message.error('配置保存失败，请检查配置数据')
      }
    },
    
    handleCertificateEnableChange(value) {
      // 当开关关闭时，清空认证选项
      if (!value) {
        this.certificateConfig.certificateType = []
      }
    },
    
    // 通用配置生成器 - 用于快速添加新配置
    addNewConfig(configDefinition) {
      // 添加到配置定义列表
      this.configDefinitions.push(configDefinition)
      
      // 初始化对应的配置对象
      const configKey = configDefinition.configKey
      const enabledKey = configDefinition.enabledKey
      
      // 创建配置对象
      const configObj = {}
      configObj[enabledKey] = false
      
      // 根据字段定义初始化值
      configDefinition.fields.forEach(field => {
        if (field.type === 'object') {
          configObj[field.key] = {}
          field.fields.forEach(subField => {
            configObj[field.key][subField.key] = subField.default || null
          })
        } else {
          configObj[field.key] = field.default || null
        }
      })
      
      // 添加到data中
      this.$set(this, configKey, configObj)
      
      // 添加到finalConfig的解析逻辑中
      this.updateFinalConfigLogic(configDefinition)
    },
    
    // 更新finalConfig的解析逻辑
    updateFinalConfigLogic(configDefinition) {
      // 这里可以动态更新finalConfig的逻辑
      // 由于Vue的computed是静态的，这里提供一个示例方法
      console.log('新配置已添加:', configDefinition.id)
    }
  }
}
</script>

<style lang="scss">
.my-dialog-mask {
  position: fixed;
  z-index: 3000;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
}
.my-dialog-box {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  min-width: 520px;
  max-width: 90vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  outline: none;
  animation: fadeIn .2s;
}
@keyframes fadeIn {
  from { transform: translateY(40px) scale(0.98); opacity: 0; }
  to   { transform: none; opacity: 1; }
}
.my-dialog-header {
  background: #f6f8fa;
  border-bottom: 1px solid #e4e7ed;
  border-radius: 12px 12px 0 0;
  padding: 22px 28px 16px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.my-dialog-title {
  font-size: 18px;
  font-weight: 700;
  color: #222;
}
.my-dialog-close {
  font-size: 20px;
  color: #909399;
  cursor: pointer;
  transition: color .2s;
}
.my-dialog-close:hover {
  color: #f56c6c;
}
.my-dialog-body {
  padding: 28px 32px 18px 32px;
  background: #fff;
  overflow-y: auto;
  flex: 1 1 auto;
}
.my-dialog-footer {
  background: #f6f8fa;
  border-top: 1px solid #e4e7ed;
  border-radius: 0 0 12px 12px;
  padding: 16px 28px;
  text-align: right;
}
.property-config .config-section {
  margin-bottom: 32px;
  padding: 22px 24px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #409eff;
  box-shadow: 0 2px 8px rgba(64,158,255,0.06);
}
.property-config .section-header {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}
.property-config .section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  display: flex;
  align-items: center;
}
.property-config .section-title i {
  margin-right: 8px;
  color: #409eff;
  font-size: 18px;
}
.property-config .subsection-title {
  font-size: 15px;
  font-weight: 600;
  color: #409eff;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
}
.property-config .subsection-title i {
  margin-right: 6px;
  font-size: 16px;
}
.property-config .config-form {
  margin-bottom: 18px;
}
.property-config .form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}
.property-config .el-select,
.property-config .el-input-number {
  min-width: 180px;
}
.property-config .config-preview {
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid #e4e7ed;
}
.property-config .preview-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.property-config .preview-title i {
  margin-right: 8px;
  color: #409eff;
}
.property-config .preview-content {
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 14px;
  max-height: 200px;
  overflow-y: auto;
}
.property-config .preview-content pre {
  margin: 0;
  font-size: 12px;
  color: #606266;
  line-height: 1.5;
}

/* 优先级说明样式 */
.property-config .priority-explanation {
  margin-top: 20px;
  padding: 16px;
  background: #f0f9ff;
  border: 1px solid #b3d8ff;
  border-radius: 6px;
  border-left: 4px solid #409eff;
}

.property-config .explanation-title {
  font-size: 14px;
  font-weight: 600;
  color: #409eff;
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
}

.property-config .explanation-title i {
  margin-right: 6px;
  font-size: 16px;
}

.property-config .priority-list {
  margin-top: 8px;
}

.property-config .priority-item {
  font-size: 13px;
  color: #303133;
  line-height: 1.6;
  background: #fff;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  font-family: 'Courier New', monospace;
}

.property-config .priority-line {
  margin-bottom: 4px;
  word-break: break-all;
}

.property-config .priority-line:last-child {
  margin-bottom: 0;
}

/* 修复 Element UI radio 组件的可访问性问题 */
.property-config .el-radio__original {
  position: absolute !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

.property-config .el-radio__input {
  position: relative;
}

.property-config .el-radio__inner {
  position: relative;
  z-index: 1;
}

/* 确保焦点可见性 */
.property-config .el-radio:focus-within .el-radio__inner {
  outline: 2px solid #409eff;
  outline-offset: 2px;
}
</style> 